import constant from "../../constant";
import router from "../../router";
const api = constant.api + "costs";
// initial state
const state = () => ({
  all: [],
  costs: [],
  cost: {},
});

// getters
const getters = {
  getAll: (state) => {
    return state.all;
  },
  getCost: (state) => {
    return state.cost;
  },
  getCosts: (state) => {
    return state.costs;
  },
};

// actions
const actions = {
  async getAll({ commit }) {
    await this.$api.show(api + "?is_importation=1").then((response) => {
      let costs = Array.isArray(response.data) ? response.data : [];
      commit("setCosts", costs);
    });
  },
  async show({ commit }, reference) {
    await this.$api.show(api + "/" + reference).then((response) => {
      let cost = response.data;
      commit("setCost", cost);
    });
  },
  async store({ commit, dispatch }, data) {
    await this.$api
      .create(api, { ...data, is_importation: true }, { confirm: false })
      .then((response) => {
      let message = response.data.message;
      let status = response.data.status;
      dispatch("notification/store", { status, message }, { root: true });
      if (status == "success") {
        router.push({ name: "costs-index" });
      }
    });
  },
  async update({ commit, dispatch }, data) {
    await this.$api
      .update(api + "/" + data.reference, { ...data, is_importation: true }, { confirm: false })
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;
        dispatch("notification/store", { status, message }, { root: true });
        if (status == "success") {
          router.push({
            name: "costs-index",
          });
        }
      });
  },
  async destroy({ commit, dispatch }, reference) {
    await this.$api
      .delete(api + "/" + reference, { confirm: false })
      .then((response) => {
        let message = response.data.message;
        let status = response.data.status;
        let costs = response.data.data;
        dispatch("notification/store", { status, message }, { root: true });
        if (status == "success") commit("setCosts", costs);
      });
  },
};

// mutations
const mutations = {
  setCosts(state, costs) {
    state.all = costs;
    state.costs = costs;
  },
  setCost(state, cost) {
    state.cost = cost;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
